<top-banner variant="custom">
    <h2 class="title mb-3" *ngIf="selectedAsset">{{selectedAsset.site.name}} - {{selectedAsset.name}}</h2>
    <button type="button" (click)="addCertificate();" class="btn btn-success btn-round"><i class="fas fa-plus"></i>
      &nbsp;
      <strong>ADD CERTIFICATE</strong>
    </button>
</top-banner>

<div class="main-content">
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="row">
          <div class="col-md-2 cardtabs-wrapper">
            <app-card-tabs [tabitems]="tabitems"></app-card-tabs>
          </div>
          <div class="col-md-10">
            <h4 class="card-title">Asset Certificates</h4>
            <div class="mb-2 animated fadeIn">
              <!-- Table of results -->
              <div class="row">
                <div class="col-md-12">
                  <p-table [value]="certificates" selectionMode="single" [(selection)]="selectedCertificate" (onRowSelect)="onRowSelect($event)" [autoLayout]="true">
                    <ng-template pTemplate="header">
                      <tr>
                        <th>Title</th>
                        <th>Supporting Document</th>
                        <th>Expiry Date</th>
                        <th>Lock Asset On Expiry</th>
                        <th>&nbsp;</th>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-cert>
                      <tr [pSelectableRow]="cert" [ngClass]="cert.expired ? 'warning-row' : null">
                        <td>{{cert.title}}</td>
                        <td><button type="button" class="btn btn-primary btn-link text-left" (click)="viewDocument(cert.file)">{{ cert.file?.fileName }}</button></td>
                        <td>{{cert.expiryDate | date: 'E d MMM yyyy' }}</td>
                        <td class="table-cell-centered">
                          <span *ngIf="cert.lockAssetOnExpiry=== true"><i class="fas fa-check-circle success"></i></span>
                          <span *ngIf="cert.lockAssetOnExpiry === false"><i class="fas fa-times-circle danger"></i></span>
                        </td>
                        <td><button type="button" class="btn btn-danger btn-link" (click)="deleteCertificate(cert)">delete</button></td>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage" let-columns>
                      <tr>
                        <td [attr.colspan]="5">
                          No asset certificates found
                        </td>
                      </tr>
                    </ng-template>
                  </p-table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- add new certificate -->
<p-dialog header="New Asset Certificate" [(visible)]="addCertificateModal" modal="true">
  <form *ngIf="!saveInProgress" [formGroup]="addCertificateForm" (ngSubmit)="onAddCertificateFormSubmit()">
    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <label>Certificate Title</label>
          <textarea type="text" class="form-control" formControlName="title"></textarea>
        </div>
      </div>
      <div class="col-md-12">
        <div class="form-group">
          <label>Expiry Date</label>
          <p-calendar class="form-control" formControlName="expiryDate" dateFormat="dd/mm/yy" [yearNavigator]="true" [yearRange]="datepickerYearRange" [monthNavigator]="true" [minDate]="minDateValue"></p-calendar>
        </div>
      </div>
      <div class="col-md-12">
        <div class="form-group form-group-checkbox">
          <label>Lock Asset On Expiry</label>
          <p-checkbox class="form-control" formControlName="lockAssetOnExpiry" binary="true"></p-checkbox>
        </div>
      </div>

      <div class="col-md-12">
        <div class="form-group">
          <label for="certFile" class="btn btn-primary btn-round">Choose A Certificate Document File</label>
          <input type="file"
            class="form-control"
            formControlName="certFile"
            name="certFile"
            id="certFile"
            accept=".pdf, image/*, .doc, .docx, .ppt, .pptx, .pps, .ppsx, .odt, .xls, .xlsx"
            (change)="onFileChange($event)"/>
          <ng-container *ngIf="selectedDocument">
            <p>Selected Document:</p>
            <ul>
              <li>{{ selectedDocument.name }}</li>
            </ul>
          </ng-container>
        </div>
      </div>
      <div class="col-md-12" *ngIf="errorAlerts">
        <p-messages [(value)]="errorAlerts"></p-messages>
      </div>
    </div>
  </form>
  <div *ngIf="saveInProgress" style="width: 50%; margin: 0 auto">
    <p-progressSpinner></p-progressSpinner>
  </div>
  <p-footer>
    <button type="button" (click)="addCertificateModal = false" [disabled]="saveInProgress" class="my-2 btn btn-round btn-sm btn-default float-left">Cancel</button>
    <button type="button" (click)="onAddCertificateFormSubmit()" [disabled]="!addCertificateForm.valid || !selectedDocument || saveInProgress" class="my-2 btn btn-round btn-sm btn-success">Add</button>
  </p-footer>
</p-dialog>

<!-- update certificate -->
<p-dialog header="Update Asset Certificate" [(visible)]="updateCertificateModal" modal="true">
  <form *ngIf="!saveInProgress" [formGroup]="updateCertificateForm" (ngSubmit)="onUpdateCertificateFormSubmit()">
    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <label>Certificate Title</label>
          <textarea type="text" class="form-control" formControlName="title"></textarea>
        </div>
      </div>
      <div class="col-md-12">
        <div class="form-group">
          <label>Expiry Date</label>
          <p-calendar class="form-control" formControlName="expiryDate" dateFormat="dd/mm/yy" [yearNavigator]="true" [yearRange]="datepickerYearRange" [monthNavigator]="true" [minDate]="minDateValue"></p-calendar>
        </div>
      </div>
      <div class="col-md-12">
        <div class="form-group form-group-checkbox">
          <label>Lock Asset On Expiry</label>
          <p-checkbox class="form-control" formControlName="lockAssetOnExpiry" binary="true"></p-checkbox>
        </div>
      </div>

      <div class="col-md-12" *ngIf="errorAlerts">
        <p-messages [(value)]="errorAlerts"></p-messages>
      </div>
    </div>
  </form>
  <div *ngIf="saveInProgress" style="width: 50%; margin: 0 auto">
    <p-progressSpinner></p-progressSpinner>
  </div>
  <p-footer>
    <button type="button" (click)="updateCertificateModal = false" [disabled]="saveInProgress" class="my-2 btn btn-round btn-sm btn-default float-left">Cancel</button>
    <button type="button" (click)="onUpdateCertificateFormSubmit()" [disabled]="!updateCertificateForm.valid || saveInProgress" class="my-2 btn btn-round btn-sm btn-success">Update</button>
  </p-footer>
</p-dialog>

<p-dialog header="Update Asset Certificate Document" [(visible)]="replaceDocumentModal" modal="true">
  <form>
    <div class="form-group">
      <input
          #fileInput
          type="file"
          class="form-control"
          accept=".pdf, image/*, .doc, .docx, .ppt, .pptx, .pps, .ppsx, .odt, .xls, .xlsx"
          (change)="onReplaceFile($event)" />
      <div *ngIf="saveInProgress" style="width: 100px; margin: 0 auto">
        <p>
          Uploading...
        </p>
        <p-progressSpinner></p-progressSpinner>
      </div>
      <ng-container *ngIf="!saveInProgress">
        <p>
          Selected File:
        </p>
        <ul *ngIf="replaceDocumentName">
          <li>{{ replaceDocumentName }}</li>
        </ul>
        <button class="btn btn-primary btn-sm work-order-button" (click)="fileInput.click()">Replace file</button>
      </ng-container>
    </div>
  </form>
  <p-footer *ngIf="!saveInProgress">
    <button type="button" (click)="replaceDocumentModal = false" class="btn btn-sm btn-default">Cancel</button>
    <button type="button" (click)="onReplaceDocumentSubmit()" [disabled]="!selectedDocument" class="btn btn-sm btn-success">Upload</button>
  </p-footer>
</p-dialog>



